import { module } from 'modujs';
import * as cart from '@shopify/theme-cart';
import { format_price } from '../utils/cart'
import { gsap } from 'gsap'
import Store from '../utils/store'

const PREVIEW_WIDTH = 85 * 2
const PREVIEW_HEIGHT = 85 * 2

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                close: 'close'
            }
        }
    }

    init() {
        //data
        this.dataRecommendedProducts = JSON.parse(this.$('recommendedProducts')[0].innerHTML)

        this.recommendedProducts = []

        this.dataRecommendedProducts.forEach((entry) => {
            if(entry.product && entry.product.available == true) this.recommendedProducts.push(entry)
        })

        this.freeShippingThreshold = this.getData('free-shipping-threshold') || false

        if(this.freeShippingThreshold != false) {
            this.freeShippingThreshold = parseInt(this.freeShippingThreshold)
        }

        //init vue
        this.initVue()

        //first update
        this.refresh()
    }

    /**
     * Retrieve cart state
     *
     * @param
     */
    refresh() {
        return cart.getState().then(state => {
            this.updateState(state)
        })
    }

    /**
     * Add item to cart with variant ID
     * TODO : refactor quantity?
     *
     * @param {id}
     */
    addItem({id,quantity}) {
        cart.addItem(id, {quantity}).then(item => {
            console.log(
                `An item with a quantity of ${quantity} was added to your cart:`,
                item
            )

            this.refresh().then(() => {
                this.open()
            })
        })
    }

    /**
     * Remove item
     *
     * @param
     */
    removeItem(key) {
        cart.removeItem(key).then(state => {
            console.log(`There is now ${state.items.length} item(s) in your cart`);

            this.refresh().then(() => {
                //callback
            })
        })
    }

    /**
     * Update item
     *
     * @param
     */
    updateItem({key,quantity}) {
        cart.updateItem(key, { quantity }).then(state => {
            var item = state.items.find(item => item.key === key);
            console.log(`The item with key '${key}' now has quantity ${item.quantity}`);

            this.refresh().then(() => {
                //callback
            })
        })
    }

    /**
     * Update cart state
     *
     * @param
     */
    updateState(state) {
        this.call('updateCount', state.item_count, 'CartToggler')
        let cartItems = []
        const itemsToFetch = []
        const itemsPromises = []

        state.items.forEach((item) =>  {
            const fetchedItem = Store.state.fetchedItems.find((fetchedItem) => fetchedItem.handle == item.handle)
            if(fetchedItem) {
                cartItems.push(fetchedItem)
            } else {
                itemsToFetch.push(item)
            }
        })

        if(itemsToFetch.length) {
            itemsToFetch.forEach((item) => {
                itemsPromises.push(this.fetchProductHandle(item.handle))
            })

            Promise.all(itemsPromises).then((values) => {
                Store.state.fetchedItems.push(...values)
                cartItems = [...cartItems, ...values]

                state.items.forEach((item) => {
                    const selectedItem = cartItems.find((cartItem) => cartItem.handle == item.handle)

                    item.product_title = selectedItem.title
                    item.product_description = selectedItem.description
                    item.url = selectedItem.onlineStoreUrl ? selectedItem.onlineStoreUrl : item.url
                })

                this.app.$data.state = state
            })
        } else {
            state.items.forEach((item) => {
                const selectedItem = cartItems.find((cartItem) => cartItem.handle == item.handle)

                item.product_title = selectedItem.title
                item.product_description = selectedItem.description
                item.url = selectedItem.onlineStoreUrl ? selectedItem.onlineStoreUrl : item.url
            })

            this.app.$data.state = state
        }
    }

    /**
     *
     *
     * @param
     */
    fetchProductHandle(handle) {
        return new Promise(async (resolve) => {
            const query = `{
                product(handle: "${handle}") {
                    title,
                    handle,
                    onlineStoreUrl
                }
            }`;

            await fetch('/api/2023-04/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    "Access-Control-Origin": "*",
                    'X-Shopify-Storefront-Access-Token': "4e0154433436f357b67675fbbb2b75aa", //live
                    // 'X-Shopify-Storefront-Access-Token': "b85f25763a61a94dbdc54d23bb4903c8", //local
                    'Accept-Language': window.Shopify.locale
                },
                "body": query
            }).then(response => response.json()).then(response => {
                Store.state.fetchedItems.push(response.data.product)
                resolve(response.data.product)
            });
        })

    }

    /**
     * Open Cart
     *
     * @param
     */
    open() {
        document.documentElement.classList.add('has-cart-open')

        this.refresh()
    }

    /**
     * Close Cart
     *
     * @param
     */
    close() {
        document.documentElement.classList.remove('has-cart-open')
        this.call('refresh', null, 'Cart')
    }

    /**
     * Init Vue App, Add Vue plugins, etc
     *
     */
    initVue() {
        let that = this

        this.app = new Vue({
            el: this.$('app')[0],
            delimiters: ['${', '}'],
            data: () => {
                return {
                    state: false,
                    recommendedProducts: this.recommendedProducts,
                    freeShippingThreshold: this.freeShippingThreshold
                }
            },
            watch: {
                state: function (newState) {
                    if(newState) {
                        newState.items.forEach((item) => {
                            if(this.recommendedProducts.length > 0) {
                                if(item.id == this.recommendedProducts[0].variant.id) {
                                    this.recommendedProducts.shift()
                                }
                            }
                        })
                    }
                }
            },
            methods: {
                /**
                 * Remove item
                 *
                 * @param
                 */
                remove: function(key) {
                    that.removeItem(key)
                },
                /**
                 * Format price
                 *
                 * @param
                 */
                formatedCurrentPrice: function(price) {
                    return format_price(price)
                },

                /**
                 * increment quantity
                 *
                 * @param
                 */
                incrementQuantity: function(key,currentQuantity) {
                    that.updateItem({key, quantity: currentQuantity + 1})
                },

                /**
                 * increment quantity
                 *
                 * @param
                 */
                decrementQuantity: function(key,currentQuantity) {
                    let newQuantity = currentQuantity - 1
                    if(newQuantity <= 0) {
                        this.remove(key)
                    } else {
                        that.updateItem({key, quantity: newQuantity})
                    }
                },

                addToCart: function(id) {
                    that.addItem({
                        "id": id,
                        "quantity": 1
                    })
                },

                /**
                 * Update breadcrumb progress
                 *
                 * @param
                 */
                progressBar: function() {
                    let formatedThreshold = this.freeShippingThreshold*100
                    let difference = formatedThreshold - this.state.total_price

                    let progress = (formatedThreshold - difference) * 100 / formatedThreshold

                    if(progress >= 100) {
                        progress = 100
                    } else if(progress <= 0) {
                        progress = 0
                    }

                    if(this.$refs.progress) {
                        gsap.to(this.$refs.progress, 0.3, { width: `${progress}%`})
                    }
                },

                getResizedImageUrl: function(imageUrl) {
                    const splitUrl = imageUrl.split('.')
                    const sizeExtension = `_${PREVIEW_WIDTH}x${PREVIEW_HEIGHT}_crop_center.${splitUrl.pop()}`
                    return splitUrl.join('.') + sizeExtension
                },

                truncateString: function(str, num) {
                    if (str.length <= num) {
                        return str
                    }
                    return str.slice(0, num) + '...'
                }
            },
            updated: function () {
                this.$nextTick(function () {
                    that.call('update', null, 'Scroll')
                })
            }
        })
    }

    /**
     * Destroy
     *
     * @param
     */
    destroy() {
        super.destroy()
        this.app.$destroy()
    }
}
